import React, { useEffect } from 'react';
import { motion } from 'framer-motion';
import './SplashScreen.css';

export default function SplashScreen({ onComplete, minDuration = 3200 }) {
  useEffect(() => {
    const timer = setTimeout(onComplete, minDuration);
    return () => clearTimeout(timer);
  }, [onComplete, minDuration]);

  return (
    <motion.div className="gold-splash" initial={{ opacity: 1 }} exit={{ opacity: 0 }} transition={{ duration: 0.6, ease: 'easeOut' }}>
      <div className="gold-splash-background" style={{ backgroundImage: "radial-gradient(ellipse at 12% 4%,#55919822,transparent 55%),url('/splash/background.webp')" }} aria-hidden="true" />
      <div className="gold-splash-stage" dir="rtl">
        <div className="gold-splash-emblem" aria-hidden="true">
          <img src="/splash/emblem.webp" alt="" width="640" height="740" />
        </div>
        <h1 className="gold-splash-wordmark" dir="ltr">Esf.Gold</h1>
        <p className="gold-splash-subtitle">آبشده خرّمی</p>
        <svg className="gold-splash-ribbon" viewBox="0 0 1000 500" fill="none" aria-hidden="true">
          <defs><linearGradient id="splash-ribbon-gold"><stop stopColor="#c7923a" stopOpacity="0" /><stop offset=".35" stopColor="#ffdb88" /><stop offset=".7" stopColor="#ffe2a2" /><stop offset="1" stopColor="#c7923a" stopOpacity="0" /></linearGradient></defs>
          <path className="gold-splash-ribbon-glow" d="M-70 60 C140 440 790 470 1070 10" />
          <path className="gold-splash-ribbon-line" d="M-70 60 C140 440 790 470 1070 10" />
          <path className="gold-splash-ribbon-trace" d="M-70 60 C140 440 790 470 1070 10" />
        </svg>
        <div className="gold-splash-ingots" aria-hidden="true">
          <div className="gold-splash-ground-glow" />
          <div className="gold-splash-ingot gold-splash-ingot-back"><img src="/splash/ingot-back.webp" alt="" width="1000" height="443" /></div>
          <div className="gold-splash-ingot gold-splash-ingot-front"><img src="/splash/ingot-front.webp" alt="" width="1000" height="500" /></div>
          <span className="gold-splash-glint gold-splash-glint-one" /><span className="gold-splash-glint gold-splash-glint-two" />
        </div>
        <div className="gold-splash-loading" role="status" aria-live="polite">
          <span className="gold-splash-spinner" aria-hidden="true" />
          <p>در حال آماده‌سازی…</p>
        </div>
      </div>
    </motion.div>
  );
}
